import { Menu, pxToRem, themeGet, themeGetColor } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StickyMenuItem = styled(Menu.Item) `
  ${({ $sticky }) => $sticky &&
    `
      position: sticky;
      top: 0;
      bottom: 0;
  `};
`;
export const SearchableMenuInputContainer = styled.div `
  display: flex;
  align-items: center;
  padding-top: ${themeGet('spacing.sm')};
  padding-bottom: ${themeGet('spacing.sm')};
  padding-left: ${themeGet('spacing.xl')};

  border-radius: ${themeGet('borderRadius.md')};
  border: ${pxToRem(1)} solid ${themeGetColor('border.100')};

  transition: border-color 0.2s ease-in-out;

  &:hover {
    border-color: ${themeGetColor('border.200')};
  }
`;
export const SearchInputElement = styled.input `
  display: flex;
  flex-grow: 1;
  font-size: ${themeGet('fontSize.medium')};
  line-height: ${themeGet('lineHeight.default')};
  color: ${themeGet('colors.text.100')};
  padding: ${themeGet('spacing.md')};

  outline: none;
  border: none;

  transition: color 0.2s ease-in-out;

  &:hover {
    cursor: text;
    color: ${themeGet('colors.text.200')};
  }
`;
